/*
  Stellt Baumplot aus aktueller Eingabe in Karte dar.
*/

import { useMemo } from "react";
import { MlGeoJsonLayer } from "@mapcomponents/react-maplibre";
import * as turf from "@turf/turf";

import MlSymbolLayer from "./MlSymbolLayer";

const Baumplot2 = ({ geojson }) => {
  const symbolGeojson = useMemo(() => {
    if (!geojson) return;

    return turf.featureCollection(
      geojson.features.map((el) => {
        el.properties.bp_info =
          "Baumart: " +
          el.properties.baumart +
          "\nAzimut: " +
          el.properties.azimut +
          "\nDistanz: " +
          el.properties.distanz +
          "\nBHD: " +
          el.properties.bhd;
        return el;
      })
    );
  }, [geojson]);

  return (
    <>
      {geojson && (
        <MlGeoJsonLayer
          geojson={geojson}
          paint={{
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              ["*", ["get", "bhd"], 0.03],
            ],
            "circle-color": "brown",
            //"circle-stroke-color": "brown",
            //"circle-stroke-width": 2,
          }}
        />
      )}
      {symbolGeojson && (
        <MlSymbolLayer
          geojson={symbolGeojson}
          type="symbol"
          layout={{
            "text-field": ["get", "bp_info"],
            "text-variable-anchor": ["top", "bottom", "left", "right"],
            "text-radial-offset": 2,
            "text-size": 13,
            "text-justify": "left",
            "text-font": ["Open Sans Regular"],
          }}
        />
      )}
    </>
  );
};

export default Baumplot2;
